/* TKV site search (27/10/2026): the header search panel (snippets/tkv-search) and the machine suggestions on the
   search results page (sections/tkv-search-results).
   Parts come from Shopify predictive search (/search/suggest.json): typo-tolerant on titles, descriptions, types,
   tags and vendors; partial matches on SKUs. Machines come from assets/tkv-fitment.json and are matched here with
   make nicknames and edit-distance rules, so misspelt makes and models still land ("komatsy pc20o" -> Komatsu PC200). */
(function(){
  var cfg=window.tkvSearch||{};
  function norm(s){return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'')}
  function h(s){return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'')}
  function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')}

  /* Nicknames customers type -> make names as listed in the finder */
  var ALIAS={cat:['Caterpillar'],deere:['John Deere'],jd:['John Deere'],doosan:['Daewoo/ Doosan/ Develon'],daewoo:['Daewoo/ Doosan/ Develon'],develon:['Daewoo/ Doosan/ Develon'],
    nh:['New Holland'],caseih:['Case IH'],challenger:['AGCO Challenger','Cat Challenger'],wacker:['Wacker Neuson'],neuson:['Wacker Neuson'],finlay:['Terex Finlay']};

  /* Edit distance with transpositions, stops early once it passes max */
  function dist(a,b,max){
    if(Math.abs(a.length-b.length)>max) return max+1;
    var d=[],i,j;
    for(i=0;i<=a.length;i++) d[i]=[i];
    for(j=0;j<=b.length;j++) d[0][j]=j;
    for(i=1;i<=a.length;i++){
      var low=Infinity;
      for(j=1;j<=b.length;j++){
        var v=Math.min(d[i-1][j]+1,d[i][j-1]+1,d[i-1][j-1]+(a[i-1]===b[j-1]?0:1));
        if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1]) v=Math.min(v,d[i-2][j-2]+1);
        d[i][j]=v; if(v<low) low=v;
      }
      if(low>max) return max+1;
    }
    return d[a.length][b.length];
  }
  function tol(n){return n>=7?2:n>=4?1:0}

  var fitP=null;
  function fitment(){
    if(window.__tkvFit) return Promise.resolve(window.__tkvFit);
    if(!fitP) fitP=fetch(cfg.fitment).then(function(r){return r.ok?r.json():{}}).catch(function(){return {}}).then(function(j){window.__tkvFit=j;return j});
    return fitP;
  }

  /* Lower score = better. -1 = no match. */
  function makeScore(w,m){
    var mn=norm(m); if(!w) return -1;
    if(mn===w) return 0;
    if(w.length>=3&&mn.indexOf(w)===0) return 1;
    var t=tol(mn.length), d=dist(w,mn,t);
    return d<=t?1+d:-1;
  }
  function modelScore(r,mo){
    var mn=norm(mo);
    if(mn===r) return 0;
    if(mn.indexOf(r)===0) return 1+(mn.length-r.length)/100;
    if(r.length>=3&&mn.indexOf(r)>0) return 3;
    var t=tol(r.length); if(!t) return -1;
    var d=Math.min(dist(r,mn,t),dist(r,mn.slice(0,r.length),t));
    return d<=t?2+d:-1;
  }
  /* The first one to three words may name a make ("john deere 8rx", "cat 320", "komatsy pc200"). */
  function findMakes(words,fit){
    for(var n=Math.min(3,words.length);n>=1;n--){
      var w=norm(words.slice(0,n).join('')), hits=[];
      if(ALIAS[w]) hits=ALIAS[w].filter(function(m){return fit[m]}).map(function(m){return [m,0]});
      else Object.keys(fit).forEach(function(m){var s=makeScore(w,m); if(s>=0) hits.push([m,s]);});
      if(hits.length){hits.sort(function(a,b){return a[1]-b[1]}); return {makes:hits.map(function(x){return x[0]}),used:n};}
    }
    return {makes:[],used:0};
  }
  function modelHits(rest,pool,fit){
    var hits=[];
    if(rest.length<2) return hits;
    /* letter O typed for zero next to a digit ("pc20o") is the commonest model typo: score both readings */
    var zero=rest.replace(/(\d)o/g,'$10').replace(/o(\d)/g,'0$1');
    pool.forEach(function(m){(fit[m]||[]).forEach(function(mo){
      var s=modelScore(rest,mo), z=zero!==rest?modelScore(zero,mo):-1;
      if(z>=0&&(s<0||z<s)) s=z;
      if(s>=0) hits.push({make:m,model:mo,s:s});
    });});
    hits.sort(function(a,b){return a.s-b.s||a.model.length-b.model.length});
    return hits;
  }
  /* Words after the machine ("zx17 roller", "cat 320 sprocket") are part words, not part of the model (30/10/2026):
     try the longest run of words that names a model exactly or by prefix, and hand the leftover words back as res.extra. */
  function match(q,fit){
    var words=String(q||'').toLowerCase().split(/[\s,]+/).filter(Boolean), res={makes:[],machines:[],extra:[]};
    if(!words.length||!fit) return res;
    var fm=findMakes(words,fit), start=fm.used, after=words.slice(start);
    if(fm.makes.length&&!after.length){res.makes=fm.makes.slice(0,3); return res;}
    var pool=fm.makes.length?fm.makes:Object.keys(fit), hits=[];
    for(var k=after.length;k>=1;k--){
      var h1=modelHits(norm(after.slice(0,k).join('')),pool,fit).filter(function(x){return x.s<2});
      if(h1.length){hits=h1; res.extra=after.slice(k); break;}
    }
    if(!hits.length) hits=modelHits(norm((fm.makes.length?after:words).join('')),pool,fit);
    res.machines=hits.slice(0,6); res.makes=fm.makes.slice(0,1);
    return res;
  }
  /* Query rewritten with the matched model ("zx17 roller" -> "ZX17U roller"), so Shopify search finds that machine's parts */
  function rewrite(m){
    return m.machines.length&&m.extra.length?m.machines[0].model+' '+m.extra.join(' '):'';
  }
  function machineLink(x){
    return '<a class="tkv-srch__item" href="/collections/'+h(x.make+' '+x.model)+'" data-tkv-machine data-make="'+esc(h(x.make))+'" data-model="'+esc(x.model)+'"><span class="tkv-srch__ico" aria-hidden="true">'+(cfg.machineIcon||'')+'</span><span><strong>'+esc(x.make+' '+x.model)+'</strong><small>Parts for this machine</small></span></a>';
  }
  function makeLink(m){
    return '<a class="tkv-srch__item" href="/collections/'+h(m)+'"><span class="tkv-srch__ico" aria-hidden="true">'+(cfg.machineIcon||'')+'</span><span><strong>'+esc(m)+'</strong><small>All '+esc(m)+' parts</small></span></a>';
  }
  /* Products without their own image use the shared render for their type (same rule as snippets/tkv-product-card) */
  function fallback(t){
    var i=cfg.img||{}; t=t||'';
    if(/Rubber Track/.test(t)&&t!=='AG Rubber Track') return i.track;
    if(/Rubber Pad Bolt-on/.test(t)) return i.bolt;
    if(/Rubber Pad Clip-on/.test(t)) return i.clip;
    if(/Rubber Pad Chain-on/.test(t)) return i.chain;
    if(t==='EXC Sprocket') return i.sprocket;
    if(t==='EXC Top Roller') return i.top;
    if(t==='EXC Track Roller') return i.roller;
    return '';
  }
  function productLink(p){
    var src=(p.featured_image&&p.featured_image.url)||p.image||fallback(p.type);
    /* Hardware: thumb from the first track bolt/nut variant, else the first non-washer (Charlie 03/11/2026, stopgap until the import drops washers) */
    if(p.type==='Hardware'&&p.variants&&p.variants.length>1){
      var pv=p.variants.filter(function(x){return /track/i.test(x.title||'')})[0]||p.variants.filter(function(x){return !/washer/i.test(x.title||'')})[0];
      var vi=pv&&((pv.featured_image&&pv.featured_image.url)||pv.image); if(vi){src=vi;}
    }
    var label=String(p.type||'').replace(/^(EXC|AG) /,'').replace('Track Roller','Bottom Roller');
    return '<a class="tkv-srch__item" href="'+esc(p.url)+'"><span class="tkv-srch__thumb">'+(src?'<img src="'+esc(src)+'" alt="" loading="lazy">':'')+'</span><span><strong>'+esc(p.title)+'</strong>'+(label?'<small>'+esc(label)+'</small>':'')+'</span></a>';
  }

  /* Machine links: open the machine collection, or the part-finder fallback if that collection doesn't exist yet */
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-tkv-machine]'); if(!a) return;
    e.preventDefault();
    var url=a.getAttribute('href'), fb='/pages/part-finder?make='+encodeURIComponent(a.dataset.make)+'&model='+encodeURIComponent(a.dataset.model);
    fetch(url,{method:'HEAD'}).then(function(r){location.href=r.ok?url:fb}).catch(function(){location.href=fb});
  });

  /* Header panel */
  var btn=document.querySelector('[data-tkv-search-toggle]'), panel=document.getElementById('tkv-srch');
  if(btn&&panel){
    var input=panel.querySelector('input[name=q]'), out=panel.querySelector('[data-tkv-srch-res]'), timer=null, seq=0;
    function openP(){panel.hidden=false; btn.setAttribute('aria-expanded','true'); fitment(); setTimeout(function(){input.focus()},0);}
    function closeP(){panel.hidden=true; btn.setAttribute('aria-expanded','false'); out.hidden=true;}
    btn.addEventListener('click',function(){panel.hidden?openP():closeP()});
    panel.querySelector('[data-tkv-srch-close]').addEventListener('click',function(){closeP(); btn.focus();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!panel.hidden){closeP(); btn.focus();}});
    document.addEventListener('click',function(e){if(!panel.hidden&&!panel.contains(e.target)&&!btn.contains(e.target)) closeP();});
    function suggest(q){
      return fetch(cfg.suggest+'?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function(r){return r.ok?r.json():null}).catch(function(){return null})
        .then(function(j){return (j&&j.resources&&j.resources.results&&j.resources.results.products)||[]});
    }
    function searchUrl(q){return cfg.search+'?type=product&options%5Bprefix%5D=last&q='+encodeURIComponent(q)}
    var lastQ='', lastRw='';
    function run(){
      var q=input.value.trim(), my=++seq;
      if(q.length<2){out.hidden=true; out.innerHTML=''; return;}
      Promise.all([fitment(),suggest(q)]).then(function(v){
        if(my!==seq) return;
        var m=match(q,v[0]), rw=rewrite(m);
        /* A machine plus part words: that machine's parts come first, then the plain search results */
        return (rw?suggest(rw):Promise.resolve([])).then(function(first){
          if(my!==seq) return;
          var seen={}, prods=first.concat(v[1]).filter(function(p){if(seen[p.url]) return false; seen[p.url]=1; return true}).slice(0,6), html='';
          if(m.machines.length||m.makes.length) html+='<p class="tkv-srch__h">Machines</p>'+m.makes.map(makeLink).join('')+m.machines.map(machineLink).join('');
          if(prods.length) html+='<p class="tkv-srch__h">Parts</p>'+prods.map(productLink).join('');
          if(!html) html='<p class="tkv-srch__none">No quick matches. Press Enter to search everything, or call <a href="tel:1300651143">1300 65 11 43</a>.</p>';
          html+='<a class="tkv-srch__all" href="'+esc(searchUrl(rw||q))+'">See all results for &ldquo;'+esc(rw||q)+'&rdquo;</a>';
          lastQ=q; lastRw=rw;
          out.innerHTML=html; out.hidden=false;
        });
      });
    }
    input.addEventListener('input',function(){clearTimeout(timer); timer=setTimeout(run,180);});
    /* Enter runs the rewritten query when one exists, so the results page lists the machine's parts */
    var form=input.form;
    if(form) form.addEventListener('submit',function(e){
      if(lastRw&&lastQ===input.value.trim()){e.preventDefault(); location.href=searchUrl(lastRw);}
    });
  }

  /* Search results page: machines matching the query, above the product results */
  document.querySelectorAll('[data-tkv-sr-machines]').forEach(function(box){
    var q=box.dataset.q; if(!q) return;
    fitment().then(function(fit){
      var m=match(q,fit); if(!m.machines.length&&!m.makes.length) return;
      box.querySelector('[data-list]').innerHTML=m.makes.map(makeLink).join('')+m.machines.map(machineLink).join('');
      box.hidden=false;
    });
  });
})();
